// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__x0fTm","inputWrap":"CustomTip_inputWrap__366L-"};